import React, { useEffect, useState } from 'react';
import { getWeatherForecast } from '../services/WeatherService';
import { Container, ListGroup, ListGroupItem } from 'react-bootstrap';

const WeatherForecastPage = () => {
    const [forecast, setForecast] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await getWeatherForecast();
            setForecast(data);
        };

        fetchData();
    }, []);

    return (
        <Container>
            <h1>Weather Forecast</h1>
            <ListGroup>
                {forecast.map((weather, index) => (
                    <ListGroupItem key={index}>
                        {weather.date} - {weather.summary} - {weather.temperatureC}°C
                    </ListGroupItem>
                ))}
            </ListGroup>
        </Container>
    );
};

export default WeatherForecastPage;
